import { Box, TableCell, TableRow, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { statusType } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";
import { monthStringFormatDate } from "../../../utils/extensions";

interface tableRowProps {
  row: any;
  handleRefreshData: any;
  value?: number;
}

const Row: React.FC<tableRowProps> = ({ row, value }) => {
  const navigate = useNavigate();

  const [activeReportsCount, setActiveReportsCount] = useState<number>();

  useEffect(() => {
    const activeReports = row?.problems.filter(
      (problem: any) =>
        problem.status?.toUpperCase() === "OPEN" ||
        problem.status?.toUpperCase() === "IN PROGRESS"
    );
    setActiveReportsCount(activeReports?.length);
  }, []);

  const imgSource =
    value === 0 ? row?.documents[0]?.previewURL : row?.thumbnailUrl;

  return (
    <TableRow
      onClick={() => {
        navigate(`/reports/${row?.id}`, {
          state: {
            rowData: row,
            value,
          },
        });
      }}
      sx={{
        cursor: "pointer",
        ":hover": {
          bgcolor: "rgba(255, 255, 255, 0.06) !important",
        },
      }}
      hover
      role="checkbox"
      tabIndex={-1}
      key={row?.id}
    >
      <TableCell
        sx={{
          minWidth: "200px",
          maxWidth: "200px",
          width: "200px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {(value === 0 ? row?.documents?.length > 0 : row?.thumbnailUrl) && (
            <Box
              sx={{
                display: "flex",
                aspectRatio: "104/72",
                justifyContent: "center",
                alignItems: "center",
                width: "104px",
                height: "72px",
                borderRadius: "3px",
              }}
            >
              <img
                style={{
                  width: "104px",
                  height: "72px",
                  borderRadius: "3px",
                }}
                alt="cover"
                // src={row?.documents[0]?.previewURL}
                src={imgSource}
              />
            </Box>
          )}
          <Typography
            sx={{ color: "white", fontWeight: "300" }}
            variant="body2"
          >
            {row?.title || "-"}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        sx={{
          width: "150px",
          minWidth: "150px",
          maxWidth: "150px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{ display: "flex", gap: "10px", width: "100%", flexWrap: "wrap" }}
        >
          <Typography
            sx={{
              color: "white",
              fontWeight: "300",
              textAlign: "center",
              width: "100%",
            }}
            variant="body2"
          >
            {row?.recentReportedDate
              ? monthStringFormatDate(row?.recentReportedDate)
              : "-"}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        sx={{
          width: "250px",
          minWidth: "250px",
          maxWidth: "250px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Box
          sx={{ display: "flex", gap: "10px", width: "100%", flexWrap: "wrap" }}
        >
          <Typography
            sx={{
              color: "white",
              fontWeight: "300",
              textAlign: "center",
              width: "100%",
            }}
            variant="body2"
          >
            {activeReportsCount || 0}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        sx={{
          width: "100px",
          minWidth: "100px",
          maxWidth: "100px",
          borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
        }}
      >
        <Typography sx={{ color: "white", fontWeight: "300" }} variant="body2">
          {row?.status ? statusType(row?.status) : "-"}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default Row;
